'use strict';

var tslib = require('tslib');
var neverthrow = require('neverthrow');
var singleton = require('@keenondrums/singleton');
var logger = require('../../logger.js');
var authApiClient = require('../authApiClient.js');
var helpers = require('../helpers.js');

exports.WebViewUserManager = class WebViewUserManager {
    _params;
    _authApiClient;
    _logger;
    constructor(params) {
        this._params = params || {};
        this._authApiClient = new authApiClient.AuthApiClient({ prefix: this._params.prefix, webPath: this._params.webPath });
        this._logger = new logger.default('WebViewUserManager');
    }
    prepare() {
        return neverthrow.ok(undefined);
    }
    async sendOtpToPhoneNumber(params) {
        const { analytics } = this._params;
        try {
            await this._authApiClient.sendOTPByPhoneNumber({ ...analytics, ...params });
        }
        catch (error) {
            if (error instanceof Error) {
                this._logger.error(error.message);
                return neverthrow.err(error);
            }
        }
        return neverthrow.ok(undefined);
    }
    async getConsents(params) {
        const { analytics: { productId } = {} } = this._params;
        try {
            const data = await this._authApiClient.getConsents({ productId, ...params });
            return neverthrow.ok(data);
        }
        catch (error) {
            if (error instanceof Error) {
                this._logger.error(error.message);
                return neverthrow.err(error);
            }
            return neverthrow.err(new Error());
        }
    }
    async loginV2(params) {
        if (typeof window === 'undefined')
            return neverthrow.err(new Error('No window defined'));
        const { prefix, webPath, analytics: { productId } = {} } = this._params;
        try {
            const { otac, username } = await this._authApiClient.verifyPhoneNumberByReferenceToken(params);
            const url = helpers.getLoginUrl({
                otac,
                hint: username,
                prefix,
                webPath,
                loginType: 'otac',
                // Это нужно для логина под новым юзером, даже если мы уже залогинены под каким-то другим
                prompt: 'login',
                productId,
                isNewWindow: false,
                isCrossDomains: false,
            });
            window.location.href = url;
        }
        catch (error) {
            if (error instanceof Error) {
                this._logger.error(error.message);
                return neverthrow.err(error);
            }
        }
        return neverthrow.ok(undefined);
    }
    /** @deprecated Use loginV2 */
    async login(params) {
        if (typeof window === 'undefined')
            return neverthrow.err(new Error('No window defined'));
        const { prefix, webPath, analytics: { productId } = {} } = this._params;
        try {
            const { otac, username } = await this._authApiClient.verifyPhoneNumberByOTP({ productId, ...params });
            const url = helpers.getLoginUrl({
                otac,
                hint: username,
                prefix,
                webPath,
                loginType: 'otac',
                // Это нужно для логина под новым юзером, даже если мы уже залогинены под каким-то другим
                prompt: 'login',
                productId,
                isNewWindow: false,
                isCrossDomains: false,
            });
            window.location.href = url;
        }
        catch (error) {
            if (error instanceof Error) {
                this._logger.error(error.message);
                return neverthrow.err(error);
            }
        }
        return neverthrow.ok(undefined);
    }
};
exports.WebViewUserManager = tslib.__decorate([
    singleton.singleton
], exports.WebViewUserManager);
//# sourceMappingURL=webViewUserManager.js.map
